import { withAuthorization } from "../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../../structure/Page/DefaultPage/DefaultPage";

const OrganizationPageContent = lazy(() => import("./OrganizationPageContent"));

function OrganizationPageInternal() {
    return (
        <DefaultPage>
            <OrganizationPageContent />
        </DefaultPage>
    );
}

export const OrganizationPage = withAuthorization(
    getAuthorizationGuard(Role.OWNER, Role.ADMIN, Role.PLANNER, Role.EMPLOYEE)
)(OrganizationPageInternal);
